<section class="wizard-panel">
  <div class="wizard-intro">
    <h2>Validation Survey Notice</h2>
    <p>
      Your insurance carrier has based your eligibility and your rate and/or premiums on information
      that was provided on an application that was completed and signed by you and your representing
      agent. This interview is intended to confirm the information that has been previously provided.
      It is critical that the information you provide today be accurate and truthful in order to
      maintain your current coverage and pricing. Any changes in information could result in changes
      to insurability or rates being charged.
    </p>
  </div>
</section>

<section class="wizard-panel">
  <div class="wizard-intro">
    <h2>Validate Your Business Information</h2>
    <p>
      Please review the information below to confirm its accuracy. Your insurance carrier has based
      your eligibility, rates and/or premiums on information that was provided on an application
      completed and signed by you and your representing agent.
    </p>
  </div>

  <div class="wizard-columns">
    <lib-card cardTitle="Business Information">
      <lib-card-row label="Business Name" [value]="business()?.businessName" />
      <lib-card-row label="Business Type" [value]="businessType()" />
      <lib-card-row label="Contractors License Number" [value]="business()?.contractorLicenseNumber" />
    </lib-card>

    <lib-card cardTitle="Addresses">
      <div class="addresses">
        <lib-address [lines]="primaryLines()" chipText="Primary" />
        <lib-address [lines]="mailingLines()" chipText="Mailing" chipType="secondary" />
      </div>
    </lib-card>
  </div>
</section>

<div class="wizard-footer">
  <lib-buttons cssType="btn-primary-outline" size="small" text="← Back" [disabled]="true" />
  <lib-buttons size="small" text="Next →" (click)="next.emit()" />
</div>
